import { isEmpty } from "lodash";

export const trimString = (string, length) => {
  if (isEmpty(string)) {
    return "";
  } else {
    return string.length > length ? string.substring(0, length) : string;
  }
};
